<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4 transition-opacity duration-300 ease-out opacity-100 animate-fadeIn"
  (click)="closePopup()"
>
  <div
    class="bg-white dark:bg-[#1E1E48] border border-transparent dark:border-[#E9E9E9] flex flex-col gap-4 rounded-2xl shadow-lg w-[530px] px-6 py-6 text-center"
    (click)="$event.stopPropagation()"
  >
    <div class="flex justify-center mb-4">
      <img src="icons/waring-2.svg" alt="warning" />
    </div>

    <h2 class="text-2xl font-medium text-secondary dark:text-[#F2F2F2]">
      {{ "Popup_Same_Airport.Title" | translate }}
    </h2>

    <p class="text-muted dark:text-[#ce8787] font-medium">
      {{ "Popup_Same_Airport.Message" | translate }}
    </p>

    <button
      (click)="closePopup()"
      class="bg-brand font-medium rounded-md px-4 py-3 w-full text-white"
    >
      {{ "Shared.Close" | translate }}
    </button>
  </div>
</div>
